import {
  SET_FLEX_DATES_RETAIL,
  SET_FLEX_DATES_EXD,
  SET_CURRENTLY_VIEWING
} from '../actionTypes'

export function setRetailFlexDates(flexDatesRetail) {
  return {
    type: SET_FLEX_DATES_RETAIL,
    flexDatesRetail
  }
}

export function setExdFlexDates(flexDatesExpressDeals) {
  return {
    type: SET_FLEX_DATES_EXD,
    flexDatesExpressDeals
  }
}

export function setCurrentlyViewing(currentlyViewing) {
  return {
    type: SET_CURRENTLY_VIEWING,
    currentlyViewing
  }
}
